module.exports = __webpack_public_path__ + "static/media/Buzz8.aaa844f4.jpg";